import 'styles/components/level-indicator.scss'
import { range } from 'lodash'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const LevelIndicator = ({ min, name, score, step }) => {
  if (score === null) {
    return null
  }

  const indicatorSteps = range(min, min + step).map(s => {
    const className = classnames('level-indicator-step', `level-${s}`, {
      'is-active': score >= s
    })
    return <div key={`${name}-${s}`} className={className} />
  })
  return <div className="level-indicator">{indicatorSteps}</div>
}

LevelIndicator.propTypes = {
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  score: PropTypes.number,
  step: PropTypes.number
}

LevelIndicator.defaultProps = {
  min: 1,
  score: null,
  step: 5
}

export default LevelIndicator
